import { render, staticRenderFns } from "./GenericConfirmationComponent.vue?vue&type=template&id=18b85e09&scoped=true&"
import script from "./GenericConfirmationComponent.vue?vue&type=script&lang=ts&"
export * from "./GenericConfirmationComponent.vue?vue&type=script&lang=ts&"
import style0 from "./GenericConfirmationComponent.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./GenericConfirmationComponent.vue?vue&type=style&index=1&id=18b85e09&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b85e09",
  null
  
)

export default component.exports